import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureAttribution, initMetaPixel, trackPageView } from '../utils/tracking';

const SITE = 'https://biosounds.es';

const PAGES = {
  '/': ['BIOSOUNDS | Neuroacústica aplicada - Música y Frecuencias Binaurales', 'Plataforma de neuroacústica aplicada. Audios con frecuencias binaurales para dormir mejor, reducir la ansiedad, concentrarte y recuperar energía.'],
  '/terapias': ['Terapias de sonido | BIOSOUNDS', 'Insomnio, ansiedad, concentración, estado de ánimo, meditación y energía: descubre cómo cada terapia de BIOSOUNDS trabaja una frecuencia distinta de tu cerebro.'],
  '/mi-programa': ['Mi programa personalizado | BIOSOUNDS', 'Responde unas preguntas y te diseñamos un programa de audios terapéuticos a tu medida.'],
  '/technology': ['Tecnología | BIOSOUNDS', 'La ciencia detrás de BIOSOUNDS: frecuencias binaurales y brainwave entrainment.'],
  '/pricing': ['Precios | BIOSOUNDS', 'Planes de suscripción de BIOSOUNDS. Empieza hoy a reequilibrar tu sistema nervioso.'],
  '/blog': ['Blog | BIOSOUNDS', 'Artículos sobre neuroacústica, sueño, ansiedad y bienestar.'],
};

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith('link') ? 'link' : 'meta');
    const m = selector.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

// Per-route canonical / title / Open Graph / Twitter tags + tracking hooks
export const SeoManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    captureAttribution();
    initMetaPixel();
    const onConsent = () => initMetaPixel();
    window.addEventListener('storage', onConsent);
    window.addEventListener('biosounds-consent', onConsent);
    return () => {
      window.removeEventListener('storage', onConsent);
      window.removeEventListener('biosounds-consent', onConsent);
    };
  }, []);

  useEffect(() => {
    trackPageView();
    const url = `${SITE}${pathname === '/' ? '/' : pathname.replace(/\/$/, '')}`;
    setMeta('link[rel="canonical"]', 'href', url);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[name="twitter:url"]', 'content', url);
    const page = PAGES[pathname];
    if (page) {
      document.title = page[0];
      setMeta('meta[name="description"]', 'content', page[1]);
      setMeta('meta[property="og:title"]', 'content', page[0]);
      setMeta('meta[property="og:description"]', 'content', page[1]);
      setMeta('meta[name="twitter:title"]', 'content', page[0]);
      setMeta('meta[name="twitter:description"]', 'content', page[1]);
    }
  }, [pathname]);

  return null;
};

export const setPageMeta = ({ title, description, image }) => {
  if (title) {
    document.title = title;
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[name="twitter:title"]', 'content', title);
  }
  if (description) {
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[name="twitter:description"]', 'content', description);
  }
  if (image) {
    setMeta('meta[property="og:image"]', 'content', image);
    setMeta('meta[name="twitter:image"]', 'content', image);
  }
};
